import React, { useState, useMemo, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Modal,
  Button,
  Form,
  Table,
  Badge,
  Dropdown,
  Card,
  Row,
  Col,
  Spinner,
  Accordion,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import OutlinedInput from "@mui/material/OutlinedInput";
import {
  Select,
  MenuItem,
  Chip,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  Paper,
  Typography,
  Box,
  TableSortLabel,
  Drawer,
  TextField,
  Divider,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { formatDateTimeLocal, formattedDateTime } from "../utility/dateFormate";
import { base_url } from "../api/api-url";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import TicketTable from "../components/TableComponents/TicketTable";
import { isAdmin, isAdminOrIsUser } from "../utility/isAdmin";
import SnackNotification from "../components/common/SnackNotification";
import { decryptText } from "../utility/cryptoUtils";
import { useDispatch, useSelector } from "react-redux";
import { fetchTicketTrash } from "../../src/store/features/tickets/ticketsSlice";
import TrashDialog from "../components/common/TrashDialog";
import { fetchCategories } from "../store/features/category/category";
import { CSVLink } from "react-csv";
import SearchBar from "../components/common/SearchBarTickets";
import { Padding } from "@mui/icons-material";
import { getVendors } from "../store/features/vendors/vendorSlice";
import { fetchClients } from "./../store/features/client/clientSlice";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const Ticket = () => {
  const [tickets, setTickets] = useState([]); // Original data from API
  const [filteredTickets, setFilteredTickets] = useState([]); // Final filtered data to display
  const [searchValue, setSearchValue] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedTicketIndex, setSelectedTicketIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [filteredStaff, setFilteredStaff] = useState([]);
  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state.category);
  const [view, setView] = useState("table");
  const [departments, setDepartments] = useState([]);
  const [staff, setStaff] = useState([]);
  const vendors = useSelector((state) => state.vendors.vendors);
  const clients = useSelector((state) => state.clientSlice.items);
  const [filters, setFilters] = useState({
    assignedDepartment: "",
    status: "",
    priority: "",
    person: "",
    month: "",
    date: "",
    fromDate: "",
    toDate: "",
  });
  // state for mail checkbox
  const [showMailFields, setShowMailFields] = useState(false);

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    issueTitle: "",
    description: "",
    escalatedBy: "",
    escalatedAt: new Date().toISOString().slice(0, 16),
    assignedTo: [],
    assignedDepartment: "",
    expectedResolutionDate: "",
    issueCategory: "",
    priority: "",
    channel: "",
    resolutionSummary: "",
    closedBy: "",
    ticketNo: "",
    deptIssueNo: "",
  });

  // Sorting state
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("ticketId");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 25;
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const ticketTrashData = useSelector((auth) => auth.ticketTrashSlice.data);
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const [open, setOpen] = useState(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);

  const ticketData = {
    isDeletedBy: "none",
    _id: "682eab100685c4781e3baa2b",
    ticketId: "TKT-0001",
    issueTitle: "Login issue",
    description: "Login issue",
    issueCategory: "Technical",
    priority: "Low",
    channel: "Call",
    status: "Open",
    isDeleted: true,
    statusHistory: [
      {
        status: "Open",
        changedAt: "2025-05-22T04:41:52.647Z",
        comment: "Ticket created",
      },
      {
        status: "Deleted",
        changedAt: "2025-05-22T10:36:04.496Z",
        comment: "Ticket marked as deleted",
      },
    ],
  };

  // Sorting function
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Sort tickets based on order and orderBy
  const sortedTickets = useMemo(() => {
    return [...filteredTickets].sort((a, b) => {
      let comparison = 0;

      // Handle different data types for sorting
      if (typeof a[orderBy] === "string" && typeof b[orderBy] === "string") {
        comparison = a[orderBy].localeCompare(b[orderBy]);
      } else if (
        orderBy === "escalatedAt" ||
        orderBy === "expectedResolutionDate"
      ) {
        // Handle date comparisons
        const dateA = new Date(a[orderBy]);
        const dateB = new Date(b[orderBy]);
        comparison = dateA - dateB;
      } else if (orderBy === "assignedDepartment") {
        // Handle department name comparison
        const deptA = a.assignedDepartment?.label || "";
        const deptB = b.assignedDepartment?.label || "";
        comparison = deptA.localeCompare(deptB);
      } else {
        // Fallback for other types
        if (a[orderBy] < b[orderBy]) {
          comparison = -1;
        } else if (a[orderBy] > b[orderBy]) {
          comparison = 1;
        }
      }

      return order === "asc" ? comparison : -comparison;
    });
  }, [filteredTickets, order, orderBy]);

  //   const sortedTickets = useMemo(() => {
  //   return [...filteredTickets].sort((a, b) => {
  //     let comparison = 0;

  //     if (typeof a[orderBy] === "string" && typeof b[orderBy] === "string") {
  //       comparison = a[orderBy].localeCompare(b[orderBy]);
  //     } else if (
  //       orderBy === "escalatedAt" ||
  //       orderBy === "expectedResolutionDate"
  //     ) {
  //       const dateA = new Date(a[orderBy]);
  //       const dateB = new Date(b[orderBy]);
  //       comparison = dateA - dateB;
  //     } else if (orderBy === "assignedDepartment") {
  //       const deptA = a.assignedDepartment?.label || "";
  //       const deptB = b.assignedDepartment?.label || "";
  //       comparison = deptA.localeCompare(deptB);
  //     } else {
  //       if (a[orderBy] < b[orderBy]) comparison = -1;
  //       else if (a[orderBy] > b[orderBy]) comparison = 1;
  //     }

  //     return order === "asc" ? comparison : -comparison;
  //   });
  // }, [filteredTickets, order, orderBy]);

  useEffect(() => {
    fetchDepartments();
    fetchStaff();
    fetchTickets();
    dispatch(fetchCategories());
    dispatch(getVendors());
    dispatch(fetchClients());
  }, []);

  useEffect(() => {
    if (staff.length > 0) {
      setFilteredStaff(staff);
    }
  }, [staff]);

  useEffect(() => {
    if (tickets) {
      setFilteredTickets(tickets);
    }
  }, [tickets]);

  // useEffect(() => {
  //   fetchTickets(page);
  // }, [page]);

  useEffect(() => {
    setSearchValue("");
  }, [filters]);

  useEffect(() => {
    const hasAnyFilter = Object.values(filters).some(
      (value) => value !== "" && value !== null && value !== undefined,
    );

    if (hasAnyFilter) {
      fetchFilteredTickets();
    } else {
      fetchTickets(page);
    }
  }, [filters, page]);

  const fetchDepartments = async () => {
    try {
      const res = await fetch(`${base_url}/department`);
      const data = await res.json();
      setDepartments(data.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const fetchTickets = async (currentPage = 1) => {
    try {
      if (isAdmin()) {
        const res = await fetch(
          `${base_url}/ticket?page=${currentPage}&limit=${limit}`,
        );
        const data = await res.json();
        setTickets(data.data);
        setTotalPages(data.pages);
        setPage(data.page);
      } else {
        const res = await fetch(
          `${base_url}/ticket?page=${currentPage}&limit=${limit}&department=${decryptText(
            localStorage.getItem("department"),
          ).replace(" ", "+")}`,
        );
        const data = await res.json();
        setTickets(data.data);
        setTotalPages(data.pages);
        setPage(data.page);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const fetchStaff = async () => {
    try {
      const res = await fetch(`${base_url}/user-getAll?populate=department`);
      const data = await res.json();
      setStaff(data.data);
    } catch (error) {
      console.error("Error fetching staff:", error);
    }
  };

  const applyFilters = (dataToFilter, currentFilters) => {
    let result = [...dataToFilter];

    // Apply each filter sequentially
    if (currentFilters.status) {
      result = result.filter(
        (ticket) => ticket.status === currentFilters.status,
      );
    }

    if (currentFilters.priority) {
      result = result.filter(
        (ticket) => ticket.priority === currentFilters.priority,
      );
    }

    if (currentFilters.department) {
      result = result.filter(
        (ticket) =>
          ticket.assignedDepartment?.label === currentFilters.department,
      );
    }

    if (currentFilters.person) {
      result = result.filter((ticket) =>
        ticket.assignedTo.some(
          (person) => person.fullName === currentFilters.person,
        ),
      );
    }

    // Date range filtering
    if (currentFilters.fromDate || currentFilters.toDate) {
      const fromDate = currentFilters.fromDate
        ? new Date(currentFilters.fromDate)
        : null;
      const toDate = currentFilters.toDate
        ? new Date(currentFilters.toDate)
        : null;

      result = result.filter((ticket) => {
        const ticketDate = new Date(ticket.escalatedAt);
        return (
          (!fromDate || ticketDate >= fromDate) &&
          (!toDate || ticketDate <= toDate)
        );
      });
    }

    // Today filter
    if (currentFilters.date === "Today") {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      result = result.filter((ticket) => {
        const ticketDate = new Date(ticket.escalatedAt);
        return ticketDate >= today;
      });
    }

    return result;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
    setSearchValue("");
    setPage(1);
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
    setSearchValue("");
    setPage(1);
  };
  const handleClearFilters = () => {
    setFilters({
      assignedDepartment: "",
      status: "",
      priority: "",
      person: "",
      month: "",
      date: "",
      fromDate: "",
      toDate: "",
    });
    setSearchValue(""); // Clear the search value
    setPage(1);
  };

  const handleSearch = (searchedData) => {
    // Apply search first, then apply other filters to the searched data
    const filtered = applyFilters(searchedData, filters);
    setFilteredTickets(filtered);
    setPage(1);
  };

  const generateTicketNo = () => `#TK-${Math.floor(Math.random() * 10000)}`;
  const generateDeptIssueNo = () => `#DPT-${Math.floor(Math.random() * 10000)}`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { escalatedAt, expectedResolutionDate } = formData;

    if (
      escalatedAt &&
      expectedResolutionDate &&
      new Date(escalatedAt) > new Date(expectedResolutionDate)
    ) {
      setSnackbarMessage(
        "Escalated Date cannot be after Expected Resolve Date",
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setLoading(false);
      return;
    }
    if (selectedTicketIndex !== null) {
      const updatedTickets = [...tickets];
      const ticketToUpdate = {
        ...updatedTickets[selectedTicketIndex],
        ...formData,
        updates: [
          ...(updatedTickets[selectedTicketIndex].updates || []),
          { date: new Date().toLocaleString(), note: "Ticket updated." },
        ],
      };

      const updatePayload = {
        ticketId: ticketToUpdate.ticketId,
        issueTitle: ticketToUpdate.issueTitle,
        description: ticketToUpdate.description,
        assignedTo: ticketToUpdate.assignedTo,
        escalatedBy: ticketToUpdate.escalatedBy,
        assignedDepartment: ticketToUpdate.assignedDepartment?._id,
        expectedResolutionDate: ticketToUpdate.expectedResolutionDate,
        expectedStartDate: ticketToUpdate.escalatedAt,
        issueCategory: ticketToUpdate.issueCategory,
        priority: ticketToUpdate.priority,
        channel: ticketToUpdate.channel,
        files: ticketToUpdate.files,
        fromDate: ticketToUpdate.fromDate,
        toDate: ticketToUpdate.toDate,
        client: ticketToUpdate.client, // will already be _id from dropdown
        vendor: ticketToUpdate.vendor,
      };

      try {
        const response = await fetch(
          `${base_url}/ticket/${ticketToUpdate._id}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(updatePayload),
          },
        );

        const data = await response.json();

        if (!response.ok || data.status === false) {
          throw new Error(
            data.message || `Failed to update ticket: ${response.statusText}`,
          );
        }

        updatedTickets[selectedTicketIndex] = ticketToUpdate;
        setTickets(updatedTickets);

        setSnackbarMessage("Ticket updated successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      } catch (error) {
        console.error("Error while updating ticket:", error);
        setSnackbarMessage(error.message || "Error updating ticket");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setLoading(false);
      }
    } else {
      const newTicket = {
        ...formData,
        ticketNo: generateTicketNo(),
        deptIssueNo: generateDeptIssueNo(),
        createdDate: new Date().toISOString().slice(0, 10),
        status: "Open",
        updates: [
          { date: new Date().toLocaleString(), note: "Ticket created." },
        ],
      };

      const ticketData = {
        ticketId: newTicket.ticketId,
        issueTitle: newTicket.issueTitle,
        description: newTicket.description,
        assignedTo: newTicket.assignedTo,
        escalatedBy: newTicket.escalatedBy,
        assignedDepartment: newTicket.assignedDepartment?._id,
        expectedResolutionDate: newTicket.expectedResolutionDate,
        expectedStartDate: newTicket.escalatedAt,
        issueCategory: newTicket.issueCategory,
        priority: newTicket.priority,
        channel: newTicket.channel,
        fromDate: newTicket.fromDate,
        toDate: newTicket.toDate,
        files: newTicket.files,
        client: showMailFields ? newTicket.client : "",
        vendor: showMailFields ? newTicket.vendor : "",
        changedByUser: `${decryptText(
          localStorage.getItem("user_name"),
        )}-${decryptText(localStorage.getItem("email"))}`,
      };

      try {
        const response = await fetch(`${base_url}/ticket-create`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(ticketData),
        });

        const data = await response.json();

        if (!response.ok || data.status === false) {
          setSnackbarMessage(data.message || "Failed to create ticket.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
          setLoading(false);
          return;
        }

        setTickets([...tickets, newTicket]);
        setSnackbarMessage("Ticket created successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      } catch (error) {
        console.error("Error while creating ticket:", error);
        setSnackbarMessage(error.message || "Error creating ticket");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    }

    fetchTickets();
    resetForm();
    setLoading(false);
  };

  const headers = [
    { label: "Ticket ID", key: "ticketId" },
    { label: "Issue Title", key: "title" },
    { label: "Escalated By", key: "escalatedBy" },
    { label: "Issue Description", key: "description" },
    { label: "Department Ticket ID", key: "depTicketId" },
    { label: "Status", key: "status" },
    { label: "Department", key: "department" },
    { label: "Assigned Staff", key: "staff" },
    { label: "Priority", key: "priority" },
    { label: "Escalation Date", key: "date" },
    { label: "Expected Resolution Date", key: "expectedResolutionDate" },
    { label: "Issue Category", key: "issueCategory" },
    { label: "Conversation", key: "conversation" },
    { label: "Resloution", key: "summary" },
    { label: "Closed By", key: "closedBy" },
  ];

  const resetForm = () => {
    setFormData({
      issueTitle: "",
      description: "",
      escalatedBy: "",
      escalatedAt: new Date().toISOString().slice(0, 16),
      assignedTo: [],
      assignedDepartment: "",
      expectedResolutionDate: "",
      issueCategory: "",
      priority: "",
      channel: "",
      resolutionSummary: "",
      closedBy: "",
      ticketNo: "",
      deptIssueNo: "",
    });
    setSelectedTicketIndex(null);
    setShowModal(false);
  };

  const handleEdit = (index) => {
    const ticket = sortedTickets[index];
    console.log(
   ticket,"ticket"
    );
    setFormData({
      ...ticket,
      client:ticket.client?._id||"",
      escalatedAt: formatDateTimeLocal(ticket.expectedStartDate),
      expectedResolutionDate: formatDateTimeLocal(
        ticket.expectedResolutionDate,
      ),
    });
    setSelectedTicketIndex(index);
    setShowModal(true);
  };

  const handleOpen = async (index) => {
    const updatedTickets = [...sortedTickets];
    updatedTickets[index].status = "Open";
    updatedTickets[index].updates?.push({
      date: new Date().toLocaleString(),
      note: "Ticket Open.",
    });
    setTickets(updatedTickets);
    const tickID = updatedTickets[index]._id;
    const tickStatus = updatedTickets[index].status;
    try {
      const response = await fetch(`${base_url}/status-update/${tickID}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: tickStatus,
          changedByUser: `${localStorage.getItem("user_name")}-${decryptText(
            localStorage.getItem("email"),
          )}`,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to create ticket: ${response.statusText}`);
      }

      const data = await response.json();
    } catch (error) {
      console.error("Error while creating ticket:", error);
    }
  };


  const handleProgress = async (index) => {
    const updatedTickets = [...sortedTickets];
    updatedTickets[index].status = "In Progress";
    updatedTickets[index].updates?.push({
      date: new Date().toLocaleString(),
      note: "Ticket In Progress.",
    });
    setTickets(updatedTickets);
    const tickID = updatedTickets[index]._id;
    const tickStatus = updatedTickets[index].status;
    try {
      const response = await fetch(`${base_url}/status-update/${tickID}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: tickStatus,
          changedByUser: `${localStorage.getItem("user_name")}-${decryptText(
            localStorage.getItem("email"),
          )}`,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to create ticket: ${response.statusText}`);
      }

      const data = await response.json();
    } catch (error) {
      console.error("Error while creating ticket:", error);
    }
  };

  const handleResloved = async (index) => {
    const updatedTickets = [...sortedTickets];
    const hasConversation = updatedTickets[index].conversation?.message;
    const hasSummary = updatedTickets[index].summary?.message;
    const hasClosedBy = updatedTickets[index].closedBy?.message;

    if (!hasConversation && !hasSummary && !hasClosedBy) {
      setSnackbarMessage(
        "Cannot resolve ticket. Please fill in at least one of these Conversation, Summary, or Closed By Details",
      );
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    updatedTickets[index].status = "Resolved";
    updatedTickets[index].updates?.push({
      date: new Date().toLocaleString(),
      note: "Ticket Resloved.",
    });
    setTickets(updatedTickets);
    const tickID = updatedTickets[index]._id;
    const tickStatus = updatedTickets[index].status;
    try {
      const response = await fetch(`${base_url}/status-update/${tickID}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: tickStatus,
          changedByUser: `${localStorage.getItem("user_name")}-${decryptText(
            localStorage.getItem("email"),
          )}`,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to create ticket: ${response.statusText}`);
      }

      const data = await response.json();
    } catch (error) {
      console.error("Error while creating ticket:", error);
    }
  };

  const handleCloseTicket = async (index) => {
    const updatedTickets = [...sortedTickets];
    console.log(
      updatedTickets.conversation?.message,
      updatedTickets.summary?.message,
      updatedTickets.closedBy?.message,
    );
    const hasConversation = updatedTickets[index].conversation?.message;
    const hasSummary = updatedTickets[index].summary?.message;
    const hasClosedBy = updatedTickets[index].closedBy?.message;

    if (!hasConversation && !hasSummary && !hasClosedBy) {
      setSnackbarMessage(
        "Cannot close ticket. Please fill in at least one of these Conversation, Summary, or Closed By Details",
      );
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    updatedTickets[index].status = "Closed";

    updatedTickets[index].updates?.push({
      date: new Date().toLocaleString(),
      note: "Ticket closed.",
    });
    setTickets(updatedTickets);
    const tickID = updatedTickets[index]._id;
    const tickStatus = updatedTickets[index].status;
    try {
      const response = await fetch(`${base_url}/status-update/${tickID}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: tickStatus,
          changedByUser: `${localStorage.getItem("user_name")}-${decryptText(
            localStorage.getItem("email"),
          )}`,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to create ticket: ${response.statusText}`);
      }

      const data = await response.json();
    } catch (error) {
      console.error("Error while creating ticket:", error);
    }
  };

  const handleEscalate = async (index) => {
    const updatedTickets = [...sortedTickets];
    updatedTickets[index].status = "Escalated";
    updatedTickets[index].updates?.push({
      date: new Date().toLocaleString(),
      note: "Ticket escalated.",
    });
    setTickets(updatedTickets);
    const tickID = updatedTickets[index]._id;
    const tickStatus = updatedTickets[index].status;

    try {
      const response = await fetch(`${base_url}/status-update/${tickID}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: tickStatus,
          changedByUser: `${localStorage.getItem("user_name")}-${decryptText(
            localStorage.getItem("email"),
          )}`,
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to create ticket: ${response.statusText}`);
      }

      const data = await response.json();
    } catch (error) {
      console.error("Error while creating ticket:", error);
    }
  };

  const fetchFilteredTickets = async (currentPage = 1) => {
    try {
      const formatDateForAPI = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toISOString().split("T")[0];
      };

      const queryParams = new URLSearchParams({
        page: currentPage,
        limit: limit,
        ...(filters.status && { status: filters.status }),
        ...(filters.priority && { priority: filters.priority }),
        ...(filters.department && { department: filters.department }),
        ...(filters.person && { assignedTo: filters.person }),
        ...(filters.date === "Today" && { today: "today" }),
        ...(filters.fromDate && {
          fromDate: formatDateForAPI(filters.fromDate),
        }),
        ...(filters.toDate && { toDate: formatDateForAPI(filters.toDate) }),
      });

      const url = `${base_url}/ticket?${queryParams.toString()}`;
      const response = await fetch(url);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to fetch tickets");
      }

      setTickets(data.data);
      setTotalPages(data.pages);
      setPage(data.page);
    } catch (error) {
      console.error("Error fetching filtered tickets:", error);
      setSnackbarMessage(error.message || "Error fetching tickets");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  console.log(searchValue, "searchValue");
  const handleDepartmentChange = (e) => {
    const selectedDeptId = e.target.value;
    const selected = departments.find((d) => d._id === selectedDeptId);

    setFormData({
      ...formData,
      assignedDepartment: selected,
      assignedTo: [],
    });

    if (selectedDeptId) {
      const deptStaff = staff.filter((person) => {
        if (Array.isArray(person.department)) {
          return person.department.some(
            (dept) =>
              dept._id === selected._id || dept.label === selected.label,
          );
        } else if (person.department && typeof person.department === "object") {
          return (
            person.department._id === selected._id ||
            person.department.label === selected.label
          );
        } else {
          return (
            person.department === selected._id ||
            person.department === selected.label
          );
        }
      });
      setFilteredStaff(deptStaff);
    } else {
      setFilteredStaff(staff);
    }
  };

  const handleFileChange = async (e) => {
    const { name, files } = e.target;
    const file = files[0];

    if (!file) return;

    const formDataUpload = new FormData();
    formDataUpload.append("file", file);

    try {
      const response = await fetch(`${base_url}/upload`, {
        method: "POST",
        body: formDataUpload,
      });

      if (!response.ok) {
        throw new Error(`Failed to upload file: ${response.statusText}`);
      }

      const data = await response.json();

      if (data.success) {
        setFormData((prev) => ({
          ...prev,
          files: data.data.url,
        }));
      } else {
        console.error("Upload failed:", data.message);
      }
    } catch (error) {
      console.error("Error while uploading file:", error);
    }
  };

  const handleDelete = (index) => {
    const deleteID = { ...sortedTickets[index] }._id;
    fetch(`${base_url}/ticket/${deleteID}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ deleteBy: localStorage.getItem("user_name") }),
    });
    fetchTickets();
  };

  const handleViewClick = (index) => {
    const updatedTickets = [...sortedTickets];
    const ticketId = updatedTickets[index]._id;
    navigate(`/viewticket/${ticketId}`);
  };

  return (
    <div className="container-fluid bg-dark text-light min-vh-100">
      <Stack spacing={4}>
        <Paper
          elevation={3}
          sx={{
            bgcolor: "#1e1e1e",
            p: 2,
            borderRadius: 2,
            color: "#fff",
            boxShadow: "0 2px 10px rgba(0,0,0,0.5)",
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexWrap={"wrap"}
            mb={3}
          >
            <Typography variant="h5" sx={{ color: "#fff", fontWeight: "bold" }}>
              Tickets
            </Typography>

            <Box
              sx={{
                display: "flex",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <SearchBar
                style={{ Padding: "0px 4px", fontSize: "15px" }}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                data={tickets}
                searchKeys={[
                  "ticketId",
                  "issueTitle",
                  "escalatedBy",
                  "description",
                ]}
                onSearch={handleSearch}
                placeholder="Search tickets..."
                clearOnFilter={true}
              />

              {isAdmin() && (
                <>
                  <Button
                    style={{ padding: "0px 8px", fontSize: "14px" }}
                    className="btn btn-primary btn-sm"
                    onClick={() => setShowModal(true)}
                  >
                    + New Ticket
                  </Button>

                  <Button
                    className="btn btn-danger btn-sm"
                    style={{ padding: "0px 8px", fontSize: "14px" }}
                    onClick={() => setOpen(true)}
                  >
                    View Deleted Ticket
                  </Button>

                  <CSVLink
                    data={sortedTickets}
                    headers={headers}
                    filename="ticket-report.csv"
                    className="btn btn-success btn-sm d-flex justify-content-center align-items-center"
                    style={{
                      padding: "0px 8px",
                      fontSize: "14px",
                      textAlign: "center",
                    }}
                  >
                    Export CSV
                  </CSVLink>
                </>
              )}
            </Box>
          </Box>

          <div className="mb-4">
            <Row className="g-2 mb-3">
              <Col md={3}>
                <Form.Select
                  name="date"
                  onChange={handleFilterChange}
                  value={filters.date}
                >
                  <option value="">All Tickets</option>
                  <option value="Today">Today</option>
                </Form.Select>
              </Col>

              {isAdminOrIsUser() && (
                <Col md={3}>
                  <Form.Select
                    name="department"
                    onChange={handleFilterChange}
                    value={filters.department}
                  >
                    <option value="">All Departments</option>
                    {departments &&
                      departments.map((dept) => (
                        <option key={dept._id} value={dept.label}>
                          {dept.label}
                        </option>
                      ))}
                  </Form.Select>
                </Col>
              )}

              <Col md={3}>
                <Form.Select
                  name="status"
                  onChange={handleFilterChange}
                  value={filters.status}
                >
                  <option value="">All Statuses</option>
                  <option>Open</option>
                  <option>Escalated</option>
                  <option>Closed</option>
                  <option>Resolved</option>
                  <option>In Progress</option>
                </Form.Select>
              </Col>

              <Col md={3}>
                <Form.Select
                  name="priority"
                  onChange={handleFilterChange}
                  value={filters.priority}
                >
                  <option value="">All Priorities</option>
                  <option>Low</option>
                  <option>Medium</option>
                  <option>High</option>
                  <option>Critical</option>
                </Form.Select>
              </Col>

              <Col md={4}>
                <Form.Select
                  name="person"
                  onChange={handleFilterChange}
                  value={filters.person}
                >
                  <option value="">All Persons</option>
                  {staff &&
                    staff.map((person) => (
                      <option key={person._id} value={person.fullName}>
                        {person.fullName} ({person.staffID})
                      </option>
                    ))}
                </Form.Select>
              </Col>

              <Col md={4} xs={12}>
                <Form.Control
                  type="date"
                  name="fromDate"
                  onChange={handleDateChange}
                  value={filters.fromDate || ""}
                  className="form-select"
                  max={filters.toDate || ""}
                />
              </Col>

              <Col md={4} xs={12}>
                <Form.Control
                  type="date"
                  name="toDate"
                  onChange={handleDateChange}
                  value={filters.toDate || ""}
                  className="form-select"
                  min={filters.fromDate || ""}
                />
              </Col>
            </Row>

            <TrashDialog
              open={open}
              onClose={() => setOpen(false)}
              ticket={ticketTrashData}
            />
          </div>
          <TicketTable
            tickets={sortedTickets}
            filters={filters}
            handleFilterChange={handleFilterChange}
            departments={departments}
            staff={staff}
            formattedDateTime={formattedDateTime}
            handleOpen={handleOpen}
            handleProgress={handleProgress}
            handleResloved={handleResloved}
            handleEscalate={handleEscalate}
            handleCloseTicket={handleCloseTicket}
            handleViewClick={handleViewClick}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            page={page}
          />
        </Paper>
      </Stack>

      <Modal
        show={showModal}
        onHide={resetForm}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedTicketIndex !== null ? "Edit Ticket" : "Create Ticket"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-4">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                {isAdmin() && selectedTicketIndex !== null && (
                  <Form.Group className="mb-3">
                    <Form.Label>Ticket Id</Form.Label>
                    <Form.Control
                      type="text"
                      name="ticketId"
                      required
                      readOnly={!isAdmin() && selectedTicketIndex !== null}
                      onChange={handleChange}
                      value={formData.ticketId}
                      placeholder="Enter Ticket Id"
                    />
                  </Form.Group>
                )}
                <Form.Group className="mb-3">
                  <Form.Label>Issue Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="issueTitle"
                    required
                    onChange={handleChange}
                    value={formData.issueTitle}
                    placeholder="Enter issue title"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Issue Details</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="description"
                    rows={4}
                    required
                    onChange={handleChange}
                    value={formData.description}
                    placeholder="Describe the issue"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Escalated By</Form.Label>
                  <Form.Control
                    type="text"
                    name="escalatedBy"
                    required
                    onChange={handleChange}
                    value={formData.escalatedBy}
                    placeholder="Enter name"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Escalated Date & Time</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    name="escalatedAt"
                    onChange={handleChange}
                    value={formData.escalatedAt}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Department</Form.Label>
                  <Form.Select
                    name="assignedDepartment"
                    required
                    value={formData.assignedDepartment?._id || ""}
                    onChange={handleDepartmentChange}
                  >
                    <option value="">Select department</option>
                    {departments &&
                      departments.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.label}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>

                <FormControl fullWidth className="mb-3">
                  <InputLabel>Assigned To</InputLabel>
                  <Select
                    labelId="assigned-to-label"
                    multiple
                    value={formData.assignedTo.map((obj) => obj._id)}
                    onChange={(e) => {
                      const selectedNames = e.target.value;
                      const selectedStaffObjects = filteredStaff.filter(
                        (person) => selectedNames.includes(person._id),
                      );
                      setFormData({
                        ...formData,
                        assignedTo: selectedStaffObjects,
                      });
                    }}
                    input={<OutlinedInput label="Assigned To" />}
                    renderValue={(selectedIds) => (
                      <div
                        style={{ display: "flex", flexWrap: "wrap", gap: 4 }}
                      >
                        {selectedIds.map((id) => {
                          const person = filteredStaff.find(
                            (p) => p._id === id,
                          );
                          return <Chip key={id} label={person?.fullName} />;
                        })}
                      </div>
                    )}
                  >
                    {filteredStaff.length > 0 ? (
                      filteredStaff.map((person) => (
                        <MenuItem key={person._id} value={person._id}>
                          <Checkbox
                            checked={
                              formData.assignedTo.findIndex(
                                (selected) => selected._id === person._id,
                              ) > -1
                            }
                          />
                          <ListItemText primary={person.fullName} />
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem disabled>
                        No staff available for selected department
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
                <Form.Group className="mb-3">
                  <Form.Label>Category</Form.Label>
                  <Form.Select
                    name="issueCategory"
                    required
                    onChange={handleChange}
                    value={formData.issueCategory}
                  >
                    <option value="">Select Category</option>
                    {categories.map((data) => (
                      <option>{data.label}</option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Priority</Form.Label>
                  <Form.Select
                    name="priority"
                    required
                    onChange={handleChange}
                    value={formData.priority}
                  >
                    <option value="">Select priority</option>
                    <option>Low</option>
                    <option>Medium</option>
                    <option>High</option>
                    <option>Critical</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Communication Channel</Form.Label>
                  <Form.Select
                    name="channel"
                    required
                    onChange={handleChange}
                    value={formData.channel}
                  >
                    <option value="">Select channel</option>
                    <option>Call</option>
                    <option>Email</option>
                    <option>WhatsApp</option>
                    <option>Social Media</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Expected Resolve Date & Time</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    name="expectedResolutionDate"
                    required
                    onChange={handleChange}
                    value={formData.expectedResolutionDate}
                  />
                </Form.Group>
                <Form.Group
                  style={{
                    display: selectedTicketIndex !== null ? "none" : "block",
                  }}
                  className="mb-3 mt-3"
                >
                  <Form.Check
                    type="checkbox"
                    label="Mail"
                    name="mail"
                    checked={showMailFields || formData.client}
                    onChange={(e) => setShowMailFields(e.target.checked)}
                  />
                </Form.Group>
                {(formData.client || showMailFields) && (
                  <Row className="mb-3 mt-3">
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Client</Form.Label>
                        <Form.Select
                          style={{
                            height: "39px !important",
                            overflowY: "scroll !important",
                          }}
                          name="client"
                          value={formData.client}
                          onChange={handleChange}
                          disabled={selectedTicketIndex !== null}
                        >
                          <option value="">Select Client</option>
                          {clients &&
                            clients.map((client) => (
                              <option key={client._id} value={client._id}>
                                {client.name}
                              </option>
                            ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Vendor</Form.Label>
                        <Form.Select
                          name="vendor"
                          value={formData.vendor}
                          onChange={handleChange}
                          style={{
                            height: "39px !important",
                            overflowY: "scroll !important",
                          }}
                          disabled={selectedTicketIndex !== null}
                        >
                          <option
                            style={{
                              height: "39px !important",
                              overflowY: "scroll !important",
                            }}
                            value=""
                          >
                            Select Vendor
                          </option>
                          {vendors &&
                            vendors.map((vendor) => (
                              <option key={vendor._id} value={vendor._id}>
                                {vendor.name}
                              </option>
                            ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                )}
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Upload Image</Form.Label>
                  <Form.Control
                    type="file"
                    name="image"
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button
              variant="success"
              type="submit"
              className="w-100"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  {selectedTicketIndex !== null
                    ? "Updating..."
                    : "Submitting..."}
                </>
              ) : selectedTicketIndex !== null ? (
                "Update Ticket"
              ) : (
                "Submit Ticket"
              )}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <SnackNotification
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        handleClose={handleSnackbarClose}
      />
    </div>
  );
};

export default Ticket;
